// extracted by mini-css-extract-plugin
export default {"appContainer":"app_appContainer__75Hvr","appRightBox":"app_appRightBox__lp6Rt"};